import { useContext } from 'react'
import { IChildPlanFormData } from '../../../contexts/ChildPlanFormDataContext'
import ParentFormDataContext from '../../../contexts/ParentFormDataContext'
import { childPlanChildName, childPlanCost, childPlanDetails } from '../../../utils/childPlanHelper'
export interface IChildPlanConfirmation {
    className?: string
    childPlan: IChildPlanFormData,
}

const ChildSelectedPremiumsTable: React.FC<IChildPlanConfirmation> = ({
    className,
    childPlan,
}) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )
    return (
        <tr className="border-collapse border-white border-2">
            <td>
                {childPlan.FirstName &&
                    childPlan.LastName ? (
                    <p className="text-black text-left text-sm p-1">
                        {childPlanChildName(
                            childPlan.FirstName,
                            childPlan.LastName,
                        )}
                    </p>
                ) : (
                    ''
                )}
            </td>
            <td >
                {
                    parentFormData.PlanDuration.Duration ? (
                        <p className="text-black text-left text-sm p-1">
                            {childPlanDetails(
                                childPlan.Plan.Primary,
                                parentFormData.PlanDuration.DurationText,
                                parentFormData.AutoEnroll.Renew
                            )}
                        </p>
                    ) : (
                        ''
                    )}
            </td>
            <td>
                {
                    parentFormData.PlanDuration.Duration ? (
                        <p className="text-black  text-right text-sm p-1">
                            {childPlanCost(
                                childPlan.Plan.Premium, parentFormData.Language
                            )}
                        </p>
                    ) : (
                        ''
                    )}
            </td>
        </tr>
    )
}

export default ChildSelectedPremiumsTable
